import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import PageTitle from '../../components/PageTitle'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import DrawerWork from './DrawerWork'
import PopupWorkForm from './PopupWorkForm'
import PopupUpdateWork from './PopupUpdateWork/PopupUpdateWork'
import PopupAddPersonWork from './PopupAddPersonWork'
// Style Component
// Ant design
import { Button, message } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
// Other
import { inject, observer } from 'mobx-react'
import ListWork from './ListWork/ListWork'
import queryString from 'query-string'
import selectPeopleStore from '../../stores/selectPeopleStore'
import { useLocation } from 'react-router-dom'
import PopupElectronicReleaseForm from './PopupElectronicReleaseForm'
import utils from '../../utils'
import AccessControlAction from '../../components/AccessControlAction'
import { ACL_ACTION_TYPE } from '../../constants'
import { WorkPageWrapper } from './WorkStyledPage'
import useOpenItem from '../../hooks/useOpenItem'
import { PopupAddPersonVote, PopupEditPersonVote } from './PopupVote'

const WorkPage = props => {
  const {
    history,
    workStore,
    loadingAnimationStore,
    notificationStore,
    match,
  } = props

  const { queryParams } = workStore

  const location = useLocation()
  const queryStringParsed = queryString.parse(location.search, {
    arrayFormat: 'index',
  })

  let { code_work } = match.params
  const {
    isOpen: isVisibleDrawerWork,
    handleOpen: handleOpenDrawerWork,
    handleClose: handleCloseDrawerWork,
  } = useOpenItem()
  const {
    isOpen: isVisiblePopupWorkForm,
    handleOpen: handleOpenPopupWorkForm,
    handleClose: handleClosePopupWorkForm,
  } = useOpenItem()
  const {
    isOpen: isVisiblePopupUpdateWork,
    handleOpen: handleOpenPopupUpdateWork,
    handleClose: handleClosePopupUpdateWork,
  } = useOpenItem()
  const {
    isOpen: isVisibleAddPersonWork,
    handleOpen: handleOpenAddPersonWork,
    handleClose: handleCloseAddPersonWork,
  } = useOpenItem()
  const {
    isOpen: isVisiblePopupElectronicRelease,
    handleOpen: handleOpenPopupElectronicRelease,
    handleClose: handleClosePopupElectronicRelease,
  } = useOpenItem()
  const {
    isOpen: isVisibleAddPersonVote,
    handleOpen: handleOpenAddPersonVote,
    handleClose: handleCloseAddPersonVote,
  } = useOpenItem()

  
  const fetchDetails = async () => {
    if (code_work) {
      handleOpenDrawerWork()
      const parentId = utils.getParameterByName('parent_id')
      loadingAnimationStore.setShowSpinInline(true)
      try {
        if (parentId) {
          await workStore.getListSubWork(parentId)
        }
        await workStore.getWorkDetail(code_work)
      } catch (err) {
        history.push('/works')
        handleCloseDrawerWork()
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra')
      } finally {
        loadingAnimationStore.setShowSpinInline(false)
      }
    }
  }

  useEffect(() => {
    ;(queryStringParsed.document_code || queryStringParsed.mission_code) &&
      handleOpenPopupWorkForm()
    if (workStore.workList.length === 0) {
      workStore.setQueryParams({
        ...queryParams,
        ...queryStringParsed,
        assignee: queryStringParsed.assignee
          ? queryStringParsed.assignee.join('&')
          : null,
        page: 0,
      })
      ;(async () => {
        try {
          // Ẩn lọc công việc theo tháng theo yêu cầu mới
          // workStore.setFilter('toDateWork', moment().format(ISO_DATE_FORMAT))
          // workStore.setFilter('fromDateWork', moment().subtract(30, 'd').format(ISO_DATE_FORMAT))
          // await workStore.getWorkList()
          await fetchDetails()
        } catch (err) {
          console.log(err)
          message.error(err?.vi || 'Đã có lỗi xảy ra!')
        } finally {
        }
      })()
    }

    return () => {
      selectPeopleStore.clearSelectPeopleStore()
      workStore.clearWorkStore()
      notificationStore.clearNotificationType()
      workStore.clearQueryParams()
    }
  }, [code_work])

  const onClosesDrawerWork = () => {
    history.replace('/works')
    workStore.clearWorkDetail()
    handleCloseDrawerWork()
  }

  return (
    <WorkPageWrapper isVisibleDrawerWork={isVisibleDrawerWork}>
      <DashboardLayout>
        <Helmet>
          <title>Công việc | Can Tho Port Công việc</title>
        </Helmet>
        <PageTitle location={props.location}>
          <AccessControlAction aclActionType={ACL_ACTION_TYPE.create__WORK}>
            <Button
              type={'primary'}
              icon={<PlusOutlined />}
              onClick={() => {
                handleOpenPopupWorkForm()
              }}>
              Tạo công việc mới
            </Button>
          </AccessControlAction>
        </PageTitle>

        <ListWork
          code_work={code_work}
          handleOpenDrawerWork={handleOpenDrawerWork}
          queryStringParsed={queryStringParsed}
        />
        {isVisibleDrawerWork && (
          <DrawerWork
            openPopupWorkForm={handleOpenPopupWorkForm}
            openPopupUpdateWork={handleOpenPopupUpdateWork}
            openPopupAddPersonWork={handleOpenAddPersonWork}
            openPopupAddPersonVote={handleOpenAddPersonVote}
            openPopupElectronicRelease={handleOpenPopupElectronicRelease}
            handleOpenDrawerWork={handleOpenDrawerWork}
            onCloseDrawerWork={onClosesDrawerWork}
            isVisibleDrawerWork={isVisibleDrawerWork}
            queryStringParsed={queryStringParsed}
          />
        )}
        <PopupWorkForm
          queryStringParsed={queryStringParsed}
          isVisiblePopupWorkForm={isVisiblePopupWorkForm}
          handleCloseWorkForm={handleClosePopupWorkForm}
        />
        <PopupUpdateWork
          match={match}
          isVisiblePopupUpdateWork={isVisiblePopupUpdateWork}
          handleCloseUpdateWork={handleClosePopupUpdateWork}
        />
        <PopupAddPersonWork
          isVisibleAddPersonWork={isVisibleAddPersonWork}
          handleCloseAddPersonWork={()=>{handleCloseAddPersonWork()}}
        />
        <PopupElectronicReleaseForm
          isVisiblePopupElectronicRelease={isVisiblePopupElectronicRelease}
          handleCloseElectronicRelease={handleClosePopupElectronicRelease}
        />
        <PopupAddPersonVote
          isVisibleAddPersonVote={isVisibleAddPersonVote}
          handleCloseAddPersonVote={()=>{handleCloseAddPersonVote()}}
        />
      </DashboardLayout>
    </WorkPageWrapper>
  )
}

WorkPage.propTypes = {}

export default inject(
  'workStore',
  'loadingAnimationStore',
  'authenticationStore',
  'notificationStore'
)(observer(WorkPage))
